module.exports = __webpack_public_path__ + "static/img/optimize_plan_icon.7eca9cca.svg";